// extracted by mini-css-extract-plugin
export var icon = "_5w-1";
export var subtext = "_5w-0";